import { motion } from "framer-motion";
import { toast } from "sonner";
import { Play, Apple, Smartphone, Download } from "lucide-react";
import { usePublicData } from "../../context/PublicDataContext";

export const DownloadApp = () => {
  const { settings } = usePublicData();
  const playStoreUrl = settings.playStoreUrl;
  return (
    <section
      id="download"
      className="relative py-24 md:py-32"
      data-testid="download-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative rounded-[2.5rem] bg-[#0033FF] overflow-hidden grain px-8 py-16 md:px-16 md:py-20"
        >
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/10 blur-2xl" />
          <div className="absolute -bottom-32 -left-10 w-96 h-96 rounded-full bg-black/10 blur-2xl" />

          <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 text-white px-4 py-1.5 text-xs font-semibold mb-6">
                <Smartphone className="w-3.5 h-3.5" /> Get the app
              </span>
              <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl text-white leading-[0.95]">
                Your city,
                <br />
                in your pocket.
              </h2>
              <p className="mt-6 text-white/80 text-lg max-w-md">
                Download QuickDrop Go and get everything delivered fast.
                Available now on Android — iOS coming soon.
              </p>

              <div className="mt-9 flex flex-wrap gap-4">
                <a
                  href={playStoreUrl || "#"}
                  target={playStoreUrl ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    if (!playStoreUrl) {
                      e.preventDefault();
                      toast("Launching soon on Google Play — stay tuned!");
                    }
                  }}
                  className="group inline-flex items-center gap-3 bg-white text-[#0b1221] rounded-2xl pl-5 pr-6 py-3.5 hover:scale-[1.03] transition-transform duration-200 shadow-xl"
                  data-testid="download-android-btn"
                >
                  <Play className="w-7 h-7 text-[#0033FF]" fill="currentColor" />
                  <span className="text-left leading-tight">
                    <span className="block text-[10px] uppercase tracking-wider text-[#5e6c84]">
                      Get it on
                    </span>
                    <span className="block font-display font-bold text-lg">
                      Google Play
                    </span>
                  </span>
                </a>

                <div
                  className="inline-flex items-center gap-3 bg-white/10 border border-white/25 text-white rounded-2xl pl-5 pr-6 py-3.5"
                  data-testid="download-ios-badge"
                >
                  <Apple className="w-7 h-7" />
                  <span className="text-left leading-tight">
                    <span className="block text-[10px] uppercase tracking-wider text-white/60">
                      Coming soon on
                    </span>
                    <span className="block font-display font-bold text-lg">
                      App Store
                    </span>
                  </span>
                </div>
              </div>

              <p className="mt-6 inline-flex items-center gap-2 text-white/70 text-sm">
                <Download className="w-4 h-4" /> Free download • No hidden fees
              </p>
            </div>

            <div className="relative flex justify-center lg:justify-end">
              <motion.div
                initial={{ opacity: 0, scale: 0.85, rotate: 4 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="relative w-[260px] sm:w-[290px] rounded-[3rem] bg-white p-3 shadow-[0_40px_90px_rgba(0,0,0,0.35)]"
              >
                <div className="absolute left-1/2 -translate-x-1/2 top-3 w-28 h-5 bg-white rounded-b-2xl z-20" />
                <div className="relative rounded-[2.3rem] overflow-hidden bg-white">
                  <img
                    src="/quickdrop-app.jpg"
                    alt="QuickDrop Go mobile app home screen"
                    className="w-full h-auto block"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
